module.exports = __webpack_public_path__ + "img/thumbnail_MuteSwan_f_leucistic.3bcf54e9.png";